/**
 * Dreamlinkstore.com critical storefront safeguards.
 * Staged 2026-09-04 on an unpublished theme copy.
 */
(function () {
  'use strict';

  function containsInvalidSavings(label) {
    var text = (label.textContent || '').replace(/\s+/g, ' ').trim();

    return /(?:save|economisez|économisez|ahorra|spare|risparmia).*[-−–]\s*(?:[$€£]\s*)?\d/i.test(text) ||
      /(?:[$€£]\s*)[-−–]\s*\d/.test(text);
  }

  function sanitizeLabel(label) {
    if (label && containsInvalidSavings(label)) {
      label.remove();
    }
  }

  function replaceLegacyRefundModal(root) {
    var scope = root && root.querySelectorAll ? root : document;

    Array.prototype.forEach.call(
      scope.querySelectorAll('.product__refund-policy-link'),
      function (button) {
        if (button.tagName === 'A' && button.getAttribute('href') === '/pages/refund-policy') {
          return;
        }

        var link = document.createElement('a');
        link.className = button.className;
        link.href = '/pages/refund-policy';
        link.textContent = 'Return & Refund Policy';
        button.parentNode.replaceChild(link, button);
      }
    );

    var legacyModal = document.getElementById('modal-refunds-policy');
    if (legacyModal) {
      legacyModal.remove();
    }
  }

  function scan(root) {
    if (!root) {
      return;
    }

    var element = root.nodeType === 1 ? root : root.parentElement;

    if (!element) {
      return;
    }

    if (element.matches && element.matches('.product-label--on-sale')) {
      sanitizeLabel(element);
    }

    if (element.querySelectorAll) {
      Array.prototype.forEach.call(
        element.querySelectorAll('.product-label--on-sale'),
        sanitizeLabel
      );
      replaceLegacyRefundModal(element);
    }
  }

  function scanDocument() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.product-label--on-sale'),
      sanitizeLabel
    );
    replaceLegacyRefundModal(document);
  }

  scanDocument();
  document.addEventListener('DOMContentLoaded', scanDocument);
  document.addEventListener('variant:changed', function () {
    window.requestAnimationFrame(scanDocument);
  });

  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'characterData') {
        scan(record.target);
        return;
      }

      Array.prototype.forEach.call(record.addedNodes, scan);
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
}());

/**
 * Contact details update: 613-400-4588.
 * Also removes the retired Formuler.vip reference from store structured data.
 */
(function () {
  'use strict';

  var OLD_PHONE = /(?:\+?1[\s().-]*)?\(?613\)?[\s().-]*255[\s.-]*2702/g;
  var NEW_PHONE = '613-400-4588';
  var NEW_PHONE_LINK = 'tel:+16134004588';
  var CONTACT_AREAS = [
    '#shopify-section-announcement-bar',
    '#shopify-section-header',
    '[data-section-type="text-with-icons"]',
    '[data-section-type="rich-text"]',
    'main'
  ].join(',');

  function updateContactArea(area) {
    if (!area) {
      return;
    }

    var walker = document.createTreeWalker(area, NodeFilter.SHOW_TEXT, null, false);
    var node;

    while ((node = walker.nextNode())) {
      var parentName = node.parentElement ? node.parentElement.tagName : '';

      if (/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(parentName)) {
        continue;
      }

      var current = node.nodeValue || '';
      var updated = current.replace(OLD_PHONE, NEW_PHONE);

      if (updated !== current) {
        node.nodeValue = updated;
      }
    }

    Array.prototype.forEach.call(area.querySelectorAll('a[href^="tel:"]'), function (link) {
      var digits = (link.getAttribute('href') || '').replace(/\D/g, '');

      if (digits.slice(-10) === '6132552702') {
        link.setAttribute('href', NEW_PHONE_LINK);
      }
    });
  }

  function updateStoreStructuredData() {
    Array.prototype.forEach.call(
      document.querySelectorAll('script[type="application/ld+json"]'),
      function (script) {
        try {
          var data = JSON.parse(script.textContent || '');
          var graph = data && data['@graph'];
          var changed = false;

          if (!Array.isArray(graph)) {
            return;
          }

          graph.forEach(function (entry) {
            if (!entry || entry['@id'] !== 'https://dreamlinkstore.com/#organization') {
              return;
            }

            if (entry.telephone !== '+1-613-400-4588') {
              entry.telephone = '+1-613-400-4588';
              changed = true;
            }

            if (entry.parentOrganization && Array.isArray(entry.parentOrganization.sameAs)) {
              var before = entry.parentOrganization.sameAs.length;
              entry.parentOrganization.sameAs = entry.parentOrganization.sameAs.filter(function (url) {
                return !/^https?:\/\/(?:www\.)?formuler\.vip\/?$/i.test(url);
              });
              changed = changed || entry.parentOrganization.sameAs.length !== before;
            }
          });

          if (changed) {
            script.textContent = JSON.stringify(data);
          }
        } catch (error) {
          // Leave unrelated structured data unchanged.
        }
      }
    );
  }

  function applyContactUpdates() {
    Array.prototype.forEach.call(document.querySelectorAll(CONTACT_AREAS), updateContactArea);
    updateStoreStructuredData();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyContactUpdates);
  } else {
    applyContactUpdates();
  }
}());

/**
 * SEO and conversion improvement: keep a short collection introduction above
 * the products and move the detailed buying guide below the product grid.
 */
(function () {
  'use strict';

  var TARGET_COLLECTIONS = [
    '/collections/formuler-new',
    '/collections/dreamlink-new',
    '/collections/open-box-new'
  ];

  function normalizePath(path) {
    return path.length > 1 ? path.replace(/\/$/, '') : path;
  }

  function moveLongCollectionGuide() {
    var path = normalizePath(window.location.pathname);

    if (TARGET_COLLECTIONS.indexOf(path) === -1) {
      return;
    }

    var description = document.querySelector('.collection__description');
    var collectionContainer = document.querySelector('.collection');
    var headerInner = document.querySelector('.collection__header-inner');

    if (!description || !collectionContainer || !headerInner || description.getAttribute('data-seo-moved') === 'true') {
      return;
    }

    var firstParagraph = description.querySelector('.rte > p:first-child');

    if (firstParagraph) {
      var intro = document.createElement('div');
      intro.className = 'collection__intro rte';
      intro.appendChild(firstParagraph.cloneNode(true));
      headerInner.appendChild(intro);
      firstParagraph.remove();
    }

    description.setAttribute('data-seo-moved', 'true');
    description.setAttribute('aria-expanded', 'true');
    description.classList.add('collection__description--below-products');
    collectionContainer.appendChild(description);

    if (!document.getElementById('collection-seo-layout-styles')) {
      var style = document.createElement('style');
      style.id = 'collection-seo-layout-styles';
      style.textContent = '.collection__intro{margin-top:12px}.collection__description--below-products{margin-top:32px;padding:28px;background:var(--secondary-background);border-top:1px solid var(--border-color)}@media(max-width:640px){.collection__description--below-products{margin-top:22px;padding:22px 18px}}';
      document.head.appendChild(style);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveLongCollectionGuide);
  } else {
    moveLongCollectionGuide();
  }
}());
